import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// bootstrap
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap'
import 'bootstrap-icons/font/bootstrap-icons.css'

// global css
import '@/styles/index.scss'

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/* import specific icons */
import { faDumbbell, faPersonSwimming } from '@fortawesome/free-solid-svg-icons'

// toast
import Vue3Toasity from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'

// element-plus
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhTw from 'element-plus/dist/locale/zh-tw.mjs'

// permission control
import '@/permission' // 需要開啟登入功能時再打開

/* add icons to the library */
library.add(faDumbbell, faPersonSwimming)

const app = createApp(App)
if (process.env.NODE_ENV !== 'mock') {
  console.warn = () => { }
}

app.use(store).use(router).use(ElementPlus, { locale: zhTw }).use(
  Vue3Toasity,
  {
    autoClose: 3000
  }
).component('font-awesome-icon', FontAwesomeIcon).mount('#app')
